<div class="delete-modal">
  <div class="row">
    <div class="col">
      <h4 class="delete-modal__title">
        <i class="fa fa-trash-o" aria-hidden="true"></i>
        Удалить?
      </h4>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <ul class="delete-modal__info">
        <li class="delete-modal__info__element">Класс: <b>{{ classTitle }}</b></li>
        <li class="delete-modal__info__element">Занятие: <b> № {{ lessonNumber }}</b></li>
        <li class="delete-modal__info__element">Дата: <b>{{ lessonDate | date:'dd.MM.yyyy HH:mm' }}</b></li>
      </ul>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="delete-modal__actions">
        <button
          class="btn modal__button modal__button_primary"
          type="button"
          (click)="onSubmit()">
          Да
        </button>
        <button
          class="btn modal__button modal__button_cancel"
          type="button"
          (click)="closeDeleteModal()">
          Отмена
        </button>
      </div>
    </div>
  </div>
</div>
